import {AxiosError} from "axios";

/**
 * GET vehicle/:id with filter[context_property_id] returns 400 validation_failed when
 * the vehicle is not associated with the selected property.
 */
export function isVehicleWrongPropertyContextError(error: unknown): boolean {
  if (!(error instanceof AxiosError) || error.response?.status !== 400) return false;
  const data = error.response.data as {
    error_code?: string;
    errors?: Record<string, string[]> | string[];
  };
  if (data?.error_code !== "validation_failed") return false;
  const {errors} = data;
  if (!errors || Array.isArray(errors) || typeof errors !== "object") return false;
  return "filter.context_property_id" in errors;
}
